var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import Button from 'antd/lib/button';
import Icon from 'antd/lib/icon';
import Modal from 'antd/lib/modal';
import 'antd/lib/button/style/index.css';
import 'antd/lib/modal/style/index.css';
var ButtonDeleteRound = (function (_super) {
    __extends(ButtonDeleteRound, _super);
    function ButtonDeleteRound(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    ButtonDeleteRound.prototype.handleClick = function () {
        if (!this.props.handleRemoveRound) {
            return;
        }
        if (this.props.round.id) {
            Modal.confirm({
                title: 'Delete round?',
                content: React.createElement(React.Fragment, null,
                    React.createElement("p", null,
                        "This will delete the round, ",
                        React.createElement("strong", null, this.props.round.name),
                        ", and all the routes and scores in it. It will unlink athletes and/or teams which have been promoted to this round."),
                    " ",
                    React.createElement("p", null, "After clicking \"OK\", please save the changes to make this action permanent.")),
                onOk: this.props.handleRemoveRound,
            });
        }
        else {
            this.props.handleRemoveRound();
        }
    };
    ButtonDeleteRound.prototype.render = function () {
        return (React.createElement("div", { className: 'ant-row ant-form-item ant-form-item-no-colon' },
            React.createElement("div", { className: 'ant-form-item-label' },
                React.createElement("label", null, "\u00A0")),
            React.createElement("div", { className: 'ant-form-item-control-wrapper' },
                React.createElement(Button, { type: 'danger', size: 'large', onClick: this.handleClick, disabled: this.props.isDisabled },
                    React.createElement(Icon, { type: 'delete' })))));
    };
    return ButtonDeleteRound;
}(React.Component));
export default ButtonDeleteRound;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormCategoryPage/FormRound/ButtonDeleteRound.tsx
// module id = 1181
// module chunks = 0